export enum TransactionStatus {
    PENDING = 'PENDING',
    DONE = 'DONE',
    CANCELLED = 'CANCELLED',
    REJECTED = 'REJECTED',
    APPROVED = 'APPROVED',
    INITIALIZED = 'INITIALISED'
}
